import { useMemo } from "react";
import { useForm } from "react-hook-form";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { IParavetDropdownOption } from "@/api_framework/api_modals/Configuration";
import { NO_PARAVET_ID, NO_PARAVET_LABEL } from "@/constants";

interface CartParavetSelectCardProps {
  paravetList: IParavetDropdownOption[];
  selectedParavetId: string;
  onSelectParavet: (paravetId: string) => void;
  isLoading: boolean;
}

const CartParavetSelectCard = ({
  paravetList,
  selectedParavetId,
  onSelectParavet,
  isLoading,
}: CartParavetSelectCardProps) => {
  const { register } = useForm<{ paravet_id: string }>();

  const paravetOptions: ISelectMenuItemData[] = useMemo(
    () => [
      ...paravetList.map((paravet) => ({
        id: paravet.paravet_id,
        title: paravet.display_name || paravet.name,
        state: paravet.employee_id ? { rightLabel: paravet.employee_id } : undefined,
      })),
      { id: NO_PARAVET_ID, title: NO_PARAVET_LABEL },
    ],
    [paravetList],
  );

  if (isLoading) return <div className="h-8 w-[200px] animate-pulse rounded-md bg-[#F3F4F6]" />;

  return (
    <div className="relative w-[200px]">
      <SearchableSelectMenu
        showDropdownIcon
        withReset
        selectItems={paravetOptions}
        defaultSelected={paravetOptions.find((option) => option.id === selectedParavetId)}
        onSelectItem={(item) => onSelectParavet(item?.id ?? "")}
        placeholder="Assign Paravet *"
        register={register("paravet_id")}
        fieldError={undefined}
        errorMessages={[]}
        showDropdownWhenNoData
        dropdownNoDataContent={<span className="text-[10px] sm:text-xs">No matching paravet</span>}
        containerClassName="w-full"
        className={`!py-[5px] !text-xs !font-semibold placeholder:!text-xs placeholder:!not-italic placeholder:!font-semibold ${
          selectedParavetId ? "!text-[#0068FF]" : "!bg-red-50 !text-red-600 placeholder:!text-red-500"
        }`}
        inputContainerClassName={`!rounded-md ${
          selectedParavetId ? "!border-blue-200 hover:!border-blue-300" : "!border-red-300"
        }`}
      />
    </div>
  );
};

export default CartParavetSelectCard;
